import { Box, Typography } from "@mui/material";
import moment from "moment";
import { Fragment } from "react";
import "./BillDetails.css";

const BillDetails = ({ orderDetails }) => {
  const totalQuantity = orderDetails?.baseOrderResponse?.orderItemList?.filter((item)=> item?.voidStatus == null)?.map((item) => item?.quantity)
    ?.reduce((a, b) => a + b, 0);

  return (
    <Box
      className="bill-details-wrapper"
      sx={{ position: "relative", maxHeight: 300, overflowY: "auto" }}
    >
      <Box>
        <div class="ods-table-wrapper">
          <div class="ods-table">
            <div
              class="ods-table-row header"
              style={{
                position: "sticky",
                top: "-17px",
              }}
            >
              <div class="ods-table-cell">Item</div>
              <div class="ods-table-cell">Barcode</div>
              <div class="ods-table-cell">Qty</div>
              <div class="ods-table-cell">Rate</div>
              <div class="ods-table-cell">Value</div>
            </div>

            {orderDetails?.baseOrderResponse?.orderItemList?.map((item, index) => (
              <div className="ods-table-row" key={index}>
                <div
                  className="ods-table-cell"
                  data-title="Item"
                  style={{ textDecoration: item?.voidStatus ? "line-through" : "none" }}
                >
                  {item?.productName}
                </div>
                <div
                  className="ods-table-cell"
                  data-title="Barcode"
                  style={{ textDecoration: item?.voidStatus ? "line-through" : "none" }}
                >
                  {item?.gtin}
                </div>
                <div
                  className="ods-table-cell"
                  data-title="Qty"
                  style={{ textDecoration: item?.voidStatus ? "line-through" : "none" }}
                >
                  {item?.quantityBySpecs}
                </div>
                <div
                  className="ods-table-cell"
                  data-title="Rate"
                  style={{ textDecoration: item?.voidStatus ? "line-through" : "none" }}
                >
                  ₹ {item?.sellingPrice}
                </div>
                <div
                  className="ods-table-cell"
                  data-title="Value"
                  style={{ textDecoration: item?.voidStatus ? "line-through" : "none" }}
                >
                  ₹ {item?.subTotal}
                </div>
              </div>
            ))}

            <td
              colSpan="2"
              className="ods-table-footer"
              style={{ position: "sticky", bottom: "-18px" }}
            >
              Total
            </td>
            <td
              colSpan="1"
              className="ods-table-footer"
              style={{ position: "sticky", bottom: "-18px" }}
            >
              {totalQuantity}
            </td>
            <td
              colSpan="2"
              className="ods-table-footer"
              style={{ position: "sticky", bottom: "-18px" }}
            >
              ₹ {orderDetails?.orderBillingDetails?.grandTotal}
            </td>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default BillDetails;
